import { Redirect as RedirectDefault, RedirectProps } from 'react-router';
import React, { FC } from 'react';
import { buildLinkTo } from 'srcJs/helpers/LanguageHelper';
import app from 'srcJs/App';

const Redirect: FC<RedirectProps> = ({
  to,
  ...props
}) => <RedirectDefault to={buildLinkTo(to, app.getLang())} {...props} />;

export { Redirect };
